<script>
export default {}
</script>

<template>
  <v-row id="idoor-sub-header" no-gutters class="pb-2 pt-4 d-flex align-center">
    <v-col cols="12" md="8" sm="6">
      <div class="d-flex align-center">
        <div class="text-h5 font-weight-bold">{{
          this.$t(this.$route.name)
        }}</div>
      </div>
    </v-col>
    <v-col cols="12" md="4" sm="6" class="mt-xs-3">
      <slot></slot>
    </v-col>
  </v-row>
</template>

<style lang="sass" scoped>
#idoor-sub-header
  border-bottom: 3px solid map-get($grey, 'lighten-2')
</style>
